import { ContentDescriptionEditable } from '@/components/widget/content-description-editable';
import { VideoPlayer } from '@/features/viewers/Video';
import { formatTime } from '@/utils/timeUtils';
import { Video } from '@vivport/backend/types';

interface DetailsVideoProps {
  content: Video;
  onDescriptionSave: (description: string) => Promise<void>;
  isRegenerating: boolean;
}

export function DetailsVideo({ content: video, onDescriptionSave, isRegenerating }: DetailsVideoProps) {
  const src = `/api/files/video/${video.uri}`;
  const meta = [
    video.durationSeconds === null ? null : formatTime(video.durationSeconds),
    `${(video.size / (1024 * 1024)).toFixed(1)} MB`,
  ].filter((part): part is string => part !== null);

  return (
    <div data-testid="details-video" className="flex flex-col gap-4">
      <div className="flex flex-col items-center gap-4">
        <VideoPlayer src={src} />
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <span>{meta.join(' · ')}</span>
          {/* Some codecs a phone records (HEVC .mov) do not decode in every browser. */}
          <a href={src} download className="underline hover:text-foreground">
            Download
          </a>
        </div>
        <ContentDescriptionEditable
          description={video.description || ''}
          onSave={onDescriptionSave}
          disabled={isRegenerating}
          placeholder="Click to add description"
        />
      </div>
    </div>
  );
}
